export default __webpack_public_path__ + "static/media/104.f0ecceab.png";